import React from 'react';
import  {Badge} from 'react-bootstrap';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCog} from "@fortawesome/free-solid-svg-icons";

class Header extends React.Component {
    render() {
        const {problems_count, handleFilter, rasp} = this.props;
        if (rasp) {
            return (
                <React.Fragment>
                    <h2 class="rasp">
                        <Badge className=
                        "badge red">{problems_count}</Badge>
                        Pytanie z&nbsp;możliwością publikacji w&nbsp;Business Insider Polska, sekcja Prawo
                        <FontAwesomeIcon onClick={ handleFilter} icon={faCog}className="fa-cog"></FontAwesomeIcon>
                    </h2>
                </React.Fragment>
            )
        }
        return (
            <React.Fragment>
                <h2>
                    <Badge className=
                    "badge success">{problems_count}</Badge>
                    Nowe pytania od użytkowników
                    <FontAwesomeIcon onClick={ handleFilter} icon={faCog}className="fa-cog"></FontAwesomeIcon>
                </h2>
            </React.Fragment>
        )
    }
}

export default Header;